module.exports = __webpack_public_path__ + "static/media/woman-sadir.f729adb5.png";